import {Box} from '@dagster-io/ui-components';
import {ReCaptchaProvider} from 'next-recaptcha-v3';
import {Suspense, useState} from 'react';

import Card from '@/components/Card';
import EmailForm from '@/components/EmailForm';
import EmailSentConfirmation from '@/components/EmailSentConfirmation';
import OrDivider from '@/components/OrDivider';
import RecaptchaDisclaimer from '@/components/RecaptchaDisclaimer';
import SignUpWithProvider from '@/components/SignUpWithProvider';
import {MediumHeading} from '@/components/Text';
import styles from '@/components/css/CreateYourAccount.module.css';
import {AuthProvider} from '@/utils/AuthProvider';
import {extractLoginAppSettings} from '@/utils/extractLoginAppSettings';

const {recaptchaSiteKey} = extractLoginAppSettings();

export default function CreateYourAccount() {
  const [didSendEmail, setDidSendEmail] = useState(false);

  if (didSendEmail) {
    return (
      <Card
        responsive
        border="all"
        className={styles.checkInbox}
        flex={{direction: 'column', justifyContent: 'center'}}
      >
        <EmailSentConfirmation description="We sent you a sign in link." />
      </Card>
    );
  }

  return (
    <Card responsive>
      <Box flex={{direction: 'column', gap: 16, alignItems: 'stretch'}}>
        <MediumHeading style={{textAlign: 'center'}}>Get started for free</MediumHeading>
        <ReCaptchaProvider reCaptchaKey={recaptchaSiteKey} useEnterprise>
          {/* Email form uses `useSearchParams`, and must be wrapped in Suspense. */}
          <Suspense fallback={<div />}>
            <EmailForm
              buttonLabel="Sign up with email"
              submitPath="/signup/email"
              onDidSendEmail={() => setDidSendEmail(true)}
            />
          </Suspense>
          <RecaptchaDisclaimer />
          <OrDivider />
          {/* Signup button forms use `useSearchParams`, and must be wrapped in Suspense. */}
          <Suspense fallback={<div />}>
            <>
              <SignUpWithProvider provider={AuthProvider.Google} />
              <SignUpWithProvider provider={AuthProvider.GitHub} />
            </>
          </Suspense>
        </ReCaptchaProvider>
      </Box>
    </Card>
  );
}
